// extracted by mini-css-extract-plugin
module.exports = {"RecipeList":"_2ppxIrjjdR2yBnCVM4UptH","Image":"_1JREA3ATEa1PnrPxb2ObwR","List":"_3d0u-qi8XmAG1w9NXWr3lg"};